export const tPath = 'map.';
